// Utility helper functions related to logs
import { kmToMiles, milesToKm } from '../lib/utils';

export function totalMilesFromOdometers(odometers, metricUnits) {
  let totalMiles = 0;

  for (const vehicleNum of Object.keys(odometers)) {
    const entries = odometers[vehicleNum];
    for (const entry of entries) {
      if (entry.end) {
        let distance = entry.end - entry.start;
        if (metricUnits === false && entry.metric_units === true) {
          distance = kmToMiles(distance);
        } else if (metricUnits === true && entry.metric_units === false) {
          distance = milesToKm(distance);
        }
        totalMiles += distance;
      }
    }
  }

  return totalMiles > 0 ? Math.round(totalMiles) : 0;
}
